import { useEffect } from "react";
import axios from "axios";
import usePopupStore from "../../store/global";
import usetranslatedTextStore from "../../store/translatedText";

const useTranslatedText = () => {
    const translateStore =  usetranslatedTextStore();
    const { setTranslatedText } = translateStore
    const { setState, loader, popupShown, languageSelected, selectedLanguage, textTranslation, selectedLanguageCode, selectedText, bookType,skeleton,selectedTextArray } = usePopupStore();
    useEffect(() => {
        if (popupShown && textTranslation) {
            setTranslatedText({ translatedTextArray: [],translatedText:null })
            setState({skeleton:true});
            var ops_basepath = Config.SERVICE_BASE_PATH;
            var userId = Readium.getUserInfo().id;
            var bookId = Readium.getBookInfo() ? Readium.getBookInfo().id : Readium.bookData.id;
            var token = Readium.userInfo.accessToken;
            var URL = ops_basepath+'/user/'+userId+'/translatetext'

            if (bookType == "pdf") {
                axios({
                    url: URL,
                    method: "POST",
                        data: {
                            "textId": "DNC",
                            "bookId": bookId,
                            "sourceLanguageCode": "en",
                            "targetLanguageCode": selectedLanguageCode,
                            "translationType": "SENTENCE",
                            "text": selectedText
                        },
                        headers: { 'accessToken': token, 'platform': 'WR', 'Content-Type': 'application/json' }
                }).then((res) => {
                    if (res.data) {
                        setTranslatedText({ translatedTextArray: [res.data]})
                    }
                });
            }
            else {
                let axiosArray = []
                for (var i = 0; i < selectedTextArray.length; i++) {
                    let newPromise = axios({
                        url: URL,
                        method: "POST",
                        data: {
                            "textId": selectedTextArray[i].id,
                            "bookId": bookId,
                            "sourceLanguageCode": "en",
                            "targetLanguageCode": selectedLanguageCode,
                            "translationType": "SENTENCE",
                            "text": selectedTextArray[i].string
                        },
                        headers: { 'accessToken': token, 'platform': 'WR', 'Content-Type': 'application/json' }
                    })
                    axiosArray.push(newPromise)
                }
                axios.all(axiosArray).then(axios.spread((...responses) => {
                    let tta = []
                    responses.forEach(res => {tta.push(res.data)})
                    let curr = {}
                        curr[selectedLanguageCode] = tta
                        setTranslatedText({ 
                            translatedTextArray: tta,
                            allLanguage:{...translateStore.allLanguage,...curr}
                        })
                })).catch(error => { })
            }
        }
    }, [selectedLanguage])
}
export default useTranslatedText;